<drawer [title]="'Modifiers'" [isClosed]="false" (saveEvent)="save()" (closeEvent)="closeSection($event);">
    <div class="row drawer-content mt-4">
        <div class="col settings-container d-flex flex-column">
            <nav aria-label="breadcrumb" *ngIf="selectedLink?.item?.field">
                <ol class="breadcrumb py-1 px-2">
                    <li *ngIf="selectedLink.isLtr" class="breadcrumb-item active"><small>{{selectedLink?.item?.field.field?.fieldName || selectedLink?.item?.field.field?.label}}</small></li>
                    <li *ngIf="!selectedLink.isLtr" class="breadcrumb-item active"><small>{{selectedLink?.item?.input?.name || selectedLink?.item?.input?.fieldName || selectedLink?.item?.input?.label}}</small></li>
                    <li><span class="badge badge-pill badge-info mx-2"><i class="fas fa-arrow-right"></i></span></li>
                    <li *ngIf="selectedLink.isLtr" class="breadcrumb-item active"><small>{{selectedLink?.item?.field.input?.name || selectedLink?.item?.field.input?.fieldName || selectedLink?.item?.field.input?.label}}</small></li>
                    <li *ngIf="!selectedLink.isLtr" class="breadcrumb-item active"><small>{{selectedLink?.item?.field?.fieldName || selectedLink?.item?.field?.label}}</small></li>
                </ol>
            </nav>
            
            <div class="settings-tabs-container">
                <ul id="myTab" role="tablist" class="nav nav-tabs nav-pill d-flex text-center styleguide-tabs mt-2">
                    <li role="presentation" class="nav-item">
                        <a id="filters-tab" data-toggle="tab" data-target="#filters" role="tab" aria-controls="filters" aria-selected="true" class="nav-link active">{{"Filters" | translate}}</a>
                    </li>
                    <li role="presentation" class="nav-item" *ngIf="isGridTransformation">
                        <a id="grid-filters-tab" data-toggle="tab" data-target="#grid-filters" role="tab" aria-controls="grid-filters" aria-selected="true" class="nav-link">{{"Grid filters" | translate}}</a>
                    </li>
                    <li role="presentation" class="nav-item">
                        <a id="transformations-tab" data-toggle="tab" data-target="#transformations" role="tab" aria-controls="transformations" aria-selected="false" class="nav-link">{{"Transformations" | translate}}</a>
                    </li>
                </ul>
            </div>
            <div id="myTabContent" class="tab-content bg-transparent">
                <div id="filters" role="tabpanel" aria-labelledby="filters-tab" class="tab-pane fade active show flex-column">
                <!--
                    <transform-search
                        *ngIf="switchs.boardType === 'query' && !isNumberRelationship()"
                        [search]="transformations"
                        [switchs]="switchs">
                    </transform-search>
                -->
                    <transform-field-operator
                        *ngIf="switchs.boardType === 'query'"
                        [transformationProps]="transformations"
                        style="flex: 1; height: fit-content;"
                        class="flex-grow-0"
                        [switchs]="switchs">
                    </transform-field-operator>
                    
                    <div class="fields-group faded" style="flex: 1; flex-grow: 2; z-index: 0; overflow: hidden; max-height: 100%;">
                        <label class="d-block list-title ml-3">{{ 'Determinants' | translate }}</label>
                        <determinant-builder-new *ngIf="switchs" [serviceId]="serviceId"
                            [jsonString]="jsonDeterminant"
                            [showSaveCancelRow]=false
                            (onChange)="updateDeterminant($event)"
                            (onCancel)="closeSection($event)"
                            class="{{store.state.common.determinantSection.topLayer === 'edit' ? 'hidden' : ''}} d-flex overflow-hidden mh-100 h-100 w-100">
                        </determinant-builder-new>
                        
                    </div>
                </div>
                <div id="grid-filters" role="tabpanel" aria-labelledby="grid-filters-tab" class="tab-pane fade d-flex flex-column" *ngIf="isGridTransformation">
                    <label class="d-block list-title">{{ 'Filter grid from determinants' | translate }}</label>
                    <determinant-builder-new *ngIf="switchs" [serviceId]="serviceId"
                        [jsonString]="jsonDeterminantFilter"
                        [showSaveCancelRow]=false
                        (onChange)="updateDeterminantFilter($event)"
                        (onCancel)="closeSection($event)"
                        class="d-flex overflow-hidden mh-100 h-100 w-100 {{store.state.common.determinantSection.topLayer === 'edit' ? 'hidden' : ''}}">
                    </determinant-builder-new>
                </div>
                <div id="transformations" role="tabpanel" aria-labelledby="transformations-tab" class="tab-pane fade flex-column">
                            <transform-grid *ngIf="isGridTransformation"
                                [inputTransformations]="inputTransformations"
                                (updateTransformations)="updateTransformations($event)"
                                [distinctByFields]="distinctByFields"
                                (updateDistinctByField)="updateDistinctByField($event)"
                                [groupByFields]="groupByFields"
                                (updateGroupByField)="updateGroupByField($event)"
                                [gridId]="switchs?.item?.field?.field?.fieldKey" [serviceId]="serviceId"></transform-grid>
                            <transform-grid-groupby *ngIf="selectedLink && isGroupByEligible"
                                [inputTransformations]="inputTransformations" (updateTransformations)="updateTransformations($event)"></transform-grid-groupby>
                            <transform-value-type *ngIf="selectedLink && !selectedLink.isLtr && !isGridTransformation"
                                [inputTransformations]="inputTransformations" (updateTransformations)="updateTransformations($event)"></transform-value-type>

                            <transform-value-input *ngIf="selectedLink && !isGridTransformation"
                                [inputTransformations]="inputTransformations" (updateTransformations)="updateTransformations($event)"></transform-value-input>

                            <transform-many-to-one
                                    *ngIf="(switchs.boardType === 'query' || switchs.boardType === 'write') && haveMultipleRelations() && !isNumberRelationship()"
                                    [switchs]="switchs"
                                    [fields]="fields">
                            </transform-many-to-one>

                            <transform-input
                                    *ngIf="enableInputTransformations() && !isNumberRelationship()"
                                    [switchs]="switchs"
                                [transformations]="inputTransformations">
                            </transform-input>
                            <!--
                            <div *ngIf="((!haveMultipleRelations() && !isNumberRelationship()) || (!enableInputTransformations() && isNumberRelationship()))">
                                {{ "No transformation available yet" | translate }}
                            </div>
                            -->
                </div>
            </div>
        </div>

    </div>
</drawer>

<drawer [title]="(store.state.common.determinantSection.determinant != null && store.state.common.determinantSection.determinant.hasOwnProperty('id')) ? 'Edit Determinant' : 'Add Determinant'"
    *ngIf="store.state.common.determinantSection.topLayer === 'edit'" (saveEvent)="saveDeterminant()" [isClosed]="false" [noContentPadding]="true" (closeEvent)="closeEdit()">
    <div class="row drawer-content">
        <div class="drawer-content drawer-direct-content">
            <determinant-new
                    class="col-12 card mb-0"
                    [serviceId]="serviceId"
                    [hideHeader]="true"
                    [stickyScrolling]="true"
                    [isClosed]="false"
                    [hideButtons]="true"
                    [determinant]="store.state.common.determinantSection.determinant"
                    (formSubmit)="closeEdit()"
                    (editCancel)="closeEdit()"></determinant-new>
        </div>
    </div>
</drawer>
